// Copyright 1999-2022. Plesk International GmbH. All rights reserved.

import firebase from "firebase/compat/app";
import { getDatabase } from "firebase/database";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  uploadBytesResumable,
} from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/messaging";

// const firebaseConfigSandbox = {
//   apiKey: process.env.VUE_APP_APIKEY_SANDBOX,
//   authDomain: process.env.VUE_APP_AUTHDOMAIN_SANDBOX,
//   projectId: process.env.VUE_APP_PROJECTID_SANDBOX,
//   storageBucket: process.env.VUE_APP_STORAGEBUCKET_SANDBOX,
//   messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID_SANDBOX,
//   appId: process.env.VUE_APP_APPID_SANDBOX,
//   measurementId: process.env.VUE_APP_MEASUREMENTID_SANDBOX,
// };
// // Initialize Firebase SANDBOX
// const app = firebase.initializeApp(firebaseConfigSandbox);
// const storage = getStorage(app, process.env.VUE_APP_STORAGE_SANDBOX);

// Conexxion production
const firebaseConfigProd = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPID,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};
console.log("proyecto", firebaseConfigProd.projectId);
// Initialize Firebase PROD
const app = firebase.initializeApp(firebaseConfigProd);
const storage = getStorage(app, process.env.VUE_APP_STORAGE);

const db = app.firestore();
const database = getDatabase(app);
const auth = app.auth();
const ms = getMessaging();

export {
  db,
  database,
  auth,
  getToken,
  ms,
  onMessage,
  ref,
  storage,
  uploadBytes,
  getDownloadURL,
  uploadBytesResumable,
};
